import styled from "styled-components";

export const SignupWrapper = styled.div`
  height: 100vh;
  overflow: hidden;

  .signup-row {
    height: 100%;
    display: flex;

    .left-panel {
      background: linear-gradient(145deg, #001a14 0%, #002820 40%, #001f18 100%);
      padding: 24px 28px 24px 48px;
      display: flex;
      flex-direction: column;
      position: relative;
      overflow: hidden;
      height: 100vh;

      &::before {
        content: "";
        position: absolute;
        top: -50%;
        right: -30%;
        width: 80%;
        height: 200%;
        background: radial-gradient(ellipse at center, rgba(0, 200, 150, 0.06) 0%, transparent 70%);
        pointer-events: none;
      }

      .logo-section {
        position: relative;
        z-index: 1;
        margin-bottom: 16px;
      }

      .hero-section {
        position: relative;
        z-index: 1;

        .headline {
          color: #ffffff;
          font-size: 24px;
          font-weight: 700;
          line-height: 1.2;
          margin-bottom: 6px;
          letter-spacing: -0.5px;

          .highlight {
            background: linear-gradient(135deg, #00ffb2 0%, #00d9a9 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }
        }

        .tagline {
          color: rgba(255, 255, 255, 0.7);
          font-size: 13px;
          line-height: 1.4;
          margin-bottom: 12px;
        }

        .feature-badges {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;

          .badge {
            display: flex;
            align-items: center;
            gap: 5px;
            background: rgba(0, 200, 150, 0.1);
            border: 1px solid rgba(0, 200, 150, 0.25);
            border-radius: 16px;
            padding: 5px 12px;
            color: #00ffb2;
            font-size: 11px;
            font-weight: 500;

            .check-icon {
              width: 14px;
              height: 14px;
              background: linear-gradient(135deg, #00ffb2 0%, #00d9a9 100%);
              border-radius: 3px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #001a14;
              font-size: 8px;
            }
          }
        }
      }

      .product-image-section {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        position: relative;
        z-index: 1;
        padding: 16px 0;
        padding-left: 12px;
        min-height: 0;

        .ant-image {
          max-height: 100%;
          display: flex;
          align-items: center;
        }

        .product-image,
        .ant-image img {
          max-width: 100%;
          max-height: 320px;
          width: auto;
          object-fit: contain;
          border-radius: 10px;
          box-shadow: 0 24px 80px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(255, 255, 255, 0.08);
        }
      }

      .trusted-section {
        position: relative;
        z-index: 1;
        padding-top: 12px;
        border-top: 1px solid rgba(255, 255, 255, 0.08);

        .trusted-label {
          font-size: 9px;
          color: rgba(255, 255, 255, 0.4);
          text-transform: uppercase;
          letter-spacing: 2px;
          margin-bottom: 4px;
          font-weight: 600;
        }

        .trusted-text {
          color: rgba(255, 255, 255, 0.75);
          font-size: 12px;
          margin-bottom: 8px;
        }

        .testimonial {
          background: linear-gradient(135deg, rgba(0, 200, 150, 0.08) 0%, rgba(0, 150, 120, 0.05) 100%);
          border-left: 2px solid #00ffb2;
          padding: 8px 12px;
          border-radius: 0 6px 6px 0;

          .quote {
            color: rgba(255, 255, 255, 0.85);
            font-size: 12px;
            font-style: italic;
            margin-bottom: 2px;
          }

          .author {
            color: rgba(255, 255, 255, 0.5);
            font-size: 10px;
            font-weight: 500;
          }
        }
      }
    }

    .right-panel {
      background: linear-gradient(135deg, #f8fafa 0%, #ffffff 50%, #f5f9f8 100%);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 40px 60px;
      height: 100vh;
      overflow: hidden;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        top: -10%;
        right: -5%;
        width: 350px;
        height: 350px;
        background: radial-gradient(circle, rgba(0, 217, 169, 0.18) 0%, rgba(0, 217, 169, 0.08) 40%, transparent 70%);
        border-radius: 50%;
        filter: blur(40px);
        pointer-events: none;
      }

      &::after {
        content: "";
        position: absolute;
        bottom: -10%;
        left: -5%;
        width: 300px;
        height: 300px;
        background: radial-gradient(circle, rgba(1, 76, 117, 0.15) 0%, rgba(1, 76, 117, 0.06) 40%, transparent 70%);
        border-radius: 50%;
        filter: blur(35px);
        pointer-events: none;
      }

      .glass-sphere-1 {
        position: absolute;
        top: 12%;
        right: 15%;
        width: 180px;
        height: 180px;
        background: radial-gradient(circle at 30% 30%, rgba(0, 217, 169, 0.25), rgba(0, 217, 169, 0.12) 50%, rgba(0, 217, 169, 0.04));
        border-radius: 50%;
        filter: blur(30px);
        pointer-events: none;
      }

      .glass-sphere-2 {
        position: absolute;
        bottom: 15%;
        right: 8%;
        width: 120px;
        height: 120px;
        background: radial-gradient(circle at 30% 30%, rgba(1, 76, 117, 0.2), rgba(1, 76, 117, 0.1) 50%, rgba(1, 76, 117, 0.03));
        border-radius: 50%;
        filter: blur(25px);
        pointer-events: none;
      }

      .glass-sphere-3 {
        position: absolute;
        top: 55%;
        left: 5%;
        width: 140px;
        height: 140px;
        background: radial-gradient(circle at 30% 30%, rgba(0, 200, 150, 0.18), rgba(0, 200, 150, 0.08) 50%, transparent);
        border-radius: 50%;
        filter: blur(28px);
        pointer-events: none;
      }

      .tech-pattern {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: 
          radial-gradient(circle at 25% 25%, rgba(0, 217, 169, 0.08) 2px, transparent 2px),
          radial-gradient(circle at 75% 75%, rgba(1, 76, 117, 0.08) 2px, transparent 2px),
          radial-gradient(circle at 50% 10%, rgba(0, 200, 150, 0.06) 2px, transparent 2px),
          radial-gradient(circle at 10% 60%, rgba(0, 180, 140, 0.06) 2px, transparent 2px),
          radial-gradient(circle at 90% 40%, rgba(0, 217, 169, 0.05) 2px, transparent 2px);
        background-size: 100px 100px, 80px 80px, 60px 60px, 70px 70px, 90px 90px;
        pointer-events: none;
      }

      .signup-form-container {
        position: relative;
        z-index: 10;
        width: 100%;
        max-width: 480px;
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(20px);
        padding: 32px 36px;
        border-radius: 16px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04), inset 0 0 0 1px rgba(255, 255, 255, 0.6);

        .form-title {
          color: #014c75;
          font-size: 24px;
          font-weight: 700;
          margin-bottom: 4px;
          letter-spacing: -0.3px;
        }

        .form-subtitle {
          color: #8c8c8c;
          font-size: 14px;
          margin-bottom: 20px;
        }

        .section-label {
          font-size: 13px;
          font-weight: 600;
          color: #262626;
          margin-bottom: 10px;
        }

        .role-selection {
          display: flex;
          gap: 12px;
          margin-bottom: 20px;

          .role-card {
            flex: 1;
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 14px 16px;
            border: 1.5px solid #e8e8e8;
            border-radius: 10px;
            cursor: pointer;
            transition: all 0.2s ease;
            background: #ffffff;
            position: relative;

            &:hover {
              border-color: #00d9a9;
              background: #f8fffe;
            }

            &.selected {
              border-color: #00d9a9;
              background: #f0fdf9;

              .selection-indicator {
                background: #00d9a9;
                border-color: #00d9a9;

                &::after {
                  content: "";
                  width: 6px;
                  height: 6px;
                  background: #ffffff;
                  border-radius: 50%;
                }
              }
            }

            .role-icon {
              width: 40px;
              height: 40px;
              border-radius: 8px;
              background: linear-gradient(135deg, #e6f7ff 0%, #d6f7f0 100%);
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 18px;
              color: #014c75;
              flex-shrink: 0;
            }

            .role-content {
              flex: 1;
              min-width: 0;

              .role-title {
                font-size: 14px;
                font-weight: 600;
                color: #014c75;
                margin-bottom: 2px;
              }

              .role-description {
                font-size: 12px;
                color: #8c8c8c;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }

            .selection-indicator {
              position: absolute;
              top: 10px;
              right: 10px;
              width: 16px;
              height: 16px;
              border: 1.5px solid #d9d9d9;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              transition: all 0.2s ease;
            }
          }
        }

        .ant-form-item {
          margin-bottom: 16px;
        }

        .ant-form-item-label {
          padding-bottom: 4px;
        }

        .ant-form-item-label > label {
          font-weight: 500;
          color: #262626;
          font-size: 13px;
        }

        .ant-input {
          height: 44px;
          border-radius: 8px;
          border: 1px solid #e8e8e8;
          font-size: 14px;
          padding: 0 12px;
          transition: border-color 0.2s ease, box-shadow 0.2s ease;

          &:hover {
            border-color: #00d9a9;
          }

          &:focus {
            border-color: #00d9a9;
            box-shadow: 0 0 0 2px rgba(0, 217, 169, 0.1);
          }

          &::placeholder {
            color: #bfbfbf;
          }
        }

        .ant-input-password {
          height: 44px;
          border-radius: 8px;
          border: 1px solid #e8e8e8;
          padding: 0 12px;
          transition: border-color 0.2s ease, box-shadow 0.2s ease;

          &:hover {
            border-color: #00d9a9;
          }

          &.ant-input-affix-wrapper-focused {
            border-color: #00d9a9;
            box-shadow: 0 0 0 2px rgba(0, 217, 169, 0.1);
          }

          .ant-input {
            height: 100%;
            border: none !important;
            box-shadow: none !important;
            background: transparent;
            padding: 0 !important;

            &:hover,
            &:focus {
              border: none !important;
              box-shadow: none !important;
            }
          }

          .ant-input-suffix {
            margin-right: 4px;
          }
        }

        .submit-btn {
          width: 100%;
          height: 48px;
          background: linear-gradient(135deg, #00d9a9 0%, #00b894 100%);
          border: none;
          border-radius: 8px;
          font-size: 15px;
          font-weight: 600;
          color: #001a14;
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;

          &:hover:not(:disabled) {
            background: linear-gradient(135deg, #00e6b3 0%, #00c49b 100%);
            transform: translateY(-1px);
            box-shadow: 0 6px 20px rgba(0, 217, 169, 0.35);
          }

          &:disabled {
            background: #d9d9d9;
            cursor: not-allowed;
          }
        }

        .login-text {
          text-align: center;
          margin-top: 16px;
          color: #8c8c8c;
          font-size: 14px;
          margin-bottom: 0;

          .login-link {
            color: #00d9a9;
            font-weight: 600;
            cursor: pointer;

            &:hover {
              color: #00b894;
            }
          }
        }
      }
    }
  }

  @media (max-width: 992px) {
    .signup-row {
      .left-panel {
        display: none;
      }

      .right-panel {
        width: 100%;
        padding: 20px;
        overflow-y: auto;
      }
    }
  }
`;
